<template>
  <div class="card">
    <h2>Organization List</h2>
    <p>
      Below is a list of organizations registered within the system.
    </p>
    <div>
      <organization-table :limit="5" :allow-pagination="false" />
    </div>
    <div class="col-12">
      <router-link :to="adminOrganizationURL" class="float-right link-list">
        View Full List
      </router-link>
    </div>
  </div>
</template>

<script>
import OrganizationTable from './OrganizationTable';
import routeNames from '../../util/routeNames';

export default {
  name: 'OrganizationList',
  components: { OrganizationTable },
  data() {
    return {
      adminOrganizationURL: routeNames.ADMINORGS.PATH
    }
  },
}
</script>
